import { createContext } from "react";

import { AppointmentFormHelper } from "./AppointmentFormHelper.tsx";

export const AppointmentFormContext = createContext<AppointmentFormHelper>(
  {} as AppointmentFormHelper
);
